module.exports = __webpack_public_path__ + "img/apkQR.9c19c43d.jpg";